import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {DbResponse} from '../../shared/interceptors/db-response';
import {NotifierComponent} from '../../shared/components/notifier/notifier.component';
import {Notification} from '../../shared/components/notifier/notification';
import {NotificationType} from '../../shared/components/notifier/notification-type';
import {UserService} from '../../user/user.service';
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-email-preferences',
    templateUrl: './email-preferences.component.html',
    styleUrls: ['./email-preferences.component.scss'],
    standalone: false
})
export class EmailPreferencesComponent {
  public loading: boolean;

  private _userToken: string;
  public emailPreferencesForm: FormGroup;
  public unsubscribedFromAll: boolean;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _userService: UserService
  ) {
    if (!this._route.snapshot.params['userToken']) {
      this._router.navigateByUrl('/');
    }
    this._userToken = this._route.snapshot.params['userToken'];

    this.emailPreferencesForm = new FormGroup({
      'newsletters': new FormControl(true),
      'salesAndPromotions': new FormControl(true),
      'membersOnlyEmails': new FormControl(true),
      'productUpdates': new FormControl(true)
    });
    if (this._route.snapshot.data['emailPreferences']) {
      this.emailPreferencesForm.setValue(this._route.snapshot.data['emailPreferences']);
    }
    this.unsubscribedFromAll = true;
    this.unsubscribeFromAll();
  }

  public unsubscribeFromAll(): void {
    this.emailPreferencesForm.setValue({
      'newsletters': false,
      'salesAndPromotions': false,
      'membersOnlyEmails': false,
      'productUpdates': false
    });

    this.updateEmailPreferences();
  }

  public updateEmailPreferences(): void {
    this.loading = true;
    this._userService.updateEmailPreferences(this._userToken, this.emailPreferencesForm.value)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        this.loading = false;

        if (response.success) {
          if (Object.values(this.emailPreferencesForm.value).indexOf(true) === -1) {
            this.unsubscribedFromAll = true;
          }
          else {
            NotifierComponent.notify(new Notification(response.message, NotificationType.INFO));
          }
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

}
